import React from 'react';
import { MARKS } from '../vendor/carrier-marks/marks';

// The checkout extension already ships every carrier's mark as a data URI, so
// the invoice pages reuse those rather than adding a second set of assets that
// could drift from what the customer actually sees.
const BRANDS = [
  ['bpost', 'bpost'], ['chronopost', 'chronopost'], ['dhl', 'dhl'],
  ['geodis', 'geodis'], ['gls', 'gls'], ['ups', 'ups'],
];

/** The brand key for anything that names a carrier: "GLS France (Flex Delivery)",
 *  "GLS FlexDelivery", "DHL (Parcel (EU))", "UPS Standard". */
export function brandOf(name) {
  const n = String(name || '').toLowerCase();
  const hit = BRANDS.find(([, key]) => n.includes(key));
  return hit ? hit[1] : '';
}

/** The part after the brand: "GLS France (Flex Delivery)" -> "France (Flex Delivery)". */
export function serviceOf(name) {
  const brand = brandOf(name);
  if (!brand) return String(name || '');
  const s = String(name || '');
  const i = s.toLowerCase().indexOf(brand);
  return s.slice(i + brand.length).replace(/^[\s(]+|[)\s]+$/g, '').trim();
}

export default function CarrierLogo({ name, height = 14, className = '', showName = true }) {
  const mark = MARKS[brandOf(name)];
  if (!name) return null;
  const service = serviceOf(name);
  return (
    <span className={`inline-flex items-baseline gap-1.5 ${className}`} title={name}>
      {mark && (
        <img src={mark.src} alt="" aria-hidden
             style={{ height, width: (mark.w / mark.h) * height }}
             className="shrink-0 self-center" />
      )}
      {showName && (
        mark
          ? (service ? <span className="text-muted-foreground">{service}</span> : null)
          : <span>{name}</span>
      )}
    </span>
  );
}
